
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from '../../service/account.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class MyDocumentsService {

    appUrl = "";
    apiUrl = ""
    localAppUrl = "";
    messApi = '';
    user: any;
    loginAppUrl = "";
    activityUrl = "";
    documentsUrl = "";
    objectTaskUrl = "";
    documentsStorageUrl = "";
    integrationMisc = "";

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.appUrl = environment.appUrl;
        this.apiUrl = environment.apiUrl;
        this.messApi = environment.apiStreamUrl;
        this.localAppUrl = environment.localApiUrl;
        this.loginAppUrl = environment.appOrgUrlconfig + "Login";
        this.activityUrl = environment.activity + '/LionO360/2.0/API/';
        this.documentsUrl = environment.activity + '/LionO360/2.0/API/Task';
        this.objectTaskUrl = this.activityUrl + 'ObjectTask';
        this.documentsStorageUrl = environment.documentStorageUrl;
        this.integrationMisc = environment.integrationMisc;
    }

    getHeaders() {
        return {
            headers: new HttpHeaders({
                "organizationId": this.user.organizationId + '',
                "userId": this.user.userId + '',
                // "loginAuditId": this.user.loginAuditId + '',
                // "authToken": this.user.token,
                // "sessionId": localStorage.getItem('randomstr') + '',
                // "sourceType": 'Web',
                // "UserSource": "192.192.19.0",
            })
        };
    }

    getAllFilesAndFolders(parentFolderId) {
        return this.http.get<any>(this.documentsStorageUrl + `GetAllAttachmentsByParentFolder?parentFolderId=${parentFolderId}`)
            .toPromise()
            .then(res => res);
    }

    getAllFilesAndFoldersLite(pageNumber: number, pageSize: number, searchValue: string, moduleSearchValue: string) {
        return this.http.get<any>(this.documentsStorageUrl + 'CloudAttachment?PageNumber=' + pageNumber + '&PageSize=' + pageSize +
            '&SearchValue=' + searchValue + '&ModuleSearchValue=' + moduleSearchValue, { observe: 'response' })
            .toPromise()
            .then(res => ({
                files: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    createNewFile(data): Observable<any> {
        return this.http.post<any>(this.documentsStorageUrl + 'CloudAttachment', data);
    }

    getNewFileWaring(data: any): Observable<any> {
        return this.http.post<any>(this.documentsStorageUrl + 'CloudAttachment/CheckWarnings', data);
    }

    uploadFilesByOrganization(data): Observable<any> {
        return this.http.post<any>(this.documentsStorageUrl + 'UploadAttachmentToOrganization', data);
    }

    uploadFile(data): Observable<any> {
        return this.http.post<any>(this.documentsStorageUrl + 'UploadAttachmentToCloud', data);
    }

    getDownloadedFilesFromFolder(folderId: number) {
        return this.http.get<any>(this.documentsStorageUrl + `DownloadFilesFromCloudByFolder?folderId=${folderId}`, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    getSharedFileOrFolders(data: {
        parentFolderId: number,
        pageSize: number,
        pageNumber: number
    }): Observable<HttpResponse<any>> {
        return this.http.get(this.documentsStorageUrl + `GetAllSharedAttachments?ParentFolderId=${data?.parentFolderId}&PageSize=${data?.pageSize}&PageNumber=${data?.pageNumber}`,{ observe: 'response' })
    }

    downloadCount(attachmentId) {
        return this.http.get<any>(this.documentsStorageUrl + `UpdateDownloadCount?attachmentId=${attachmentId}`, {
            headers: this.headers,
            responseType: 'text' as 'json'
        })
            .toPromise()
            .then(res => res);
    }

    deleteFileOrFolder(id) {
        return this.http.delete<any>(this.documentsStorageUrl + `CloudAttachment/${id}`)
            .toPromise()
            .then(res => res);
    }

    deleteSharedFileOrFolder(id) {
        return this.http.delete<any>(this.documentsStorageUrl + `SharedAttachment/${id}`)
        .toPromise()
        .then(res => res);
    }

    getUsersList(data: {
        attachmentId: number,
        PageNumber: number,
        PageSize: number,
        ModuleSearchValue?: string,
    }): Observable<HttpResponse<any>> {
        // ?attachmentId=10001827&PageNumber=1&PageSize=15&SearchValue=auto
        let extendedUrl: string
        if (data?.ModuleSearchValue) {
            extendedUrl = `UsersListForFileSharing?attachmentId=${data?.attachmentId}&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}&SearchValue=${data?.ModuleSearchValue}`
        } else {
            extendedUrl = `UsersListForFileSharing?attachmentId=${data?.attachmentId}&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`

        }
        return this.http.get<any>(this.documentsStorageUrl + extendedUrl,{ observe: 'response' });
    }

    updateUserPermission(data: {
        userId: number;
        attachmentId: number;
        readable: boolean;
        writable: boolean;
        downloadable: boolean;
    }[]): Observable<any> {
        return this.http.put<any>(this.documentsStorageUrl + `ShareAttachments`, data);
    }

    downloadFilesAndFolder(data: {
        id: number;
        isDefaultContentType: boolean
    }): Observable<any> {
        return this.http.get<any>(this.documentsStorageUrl + `CloudAttachment/Download/${data?.id}?isDefaultContentType=${data?.isDefaultContentType}`);
    }

    UpdateDownloadCount(attachmentId: number): Observable<any> {
        return this.http.get<any>(this.documentsStorageUrl + `UpdateDownloadCount?attachmentId=${attachmentId}`);

    }

    sharedDocumentEdit(data: {
        attachmentId: number,
        name: string
    }) {
        return this.http.put<any>(this.documentsStorageUrl + ``, data);
    }

    downloadPublicFile(attachmentId: number, isDefaultContentType: boolean): Observable<any> {
        return this.http.get(this.integrationMisc + `ModuleUpload/Download/${attachmentId}?isDefaultContentType=${isDefaultContentType}`);
    }

    getAllVersions(attachmentId: number): Observable<any> {
        return this.http.get(this.documentsStorageUrl + `CloudAttachment/GetAllVersions/${attachmentId}`);
    }

    uploadExportedFile(folderName: string,fileName: string,extension: string, file: File): Observable<any>{
        const formData = new FormData();
        formData.append('File', file);
        return this.http.post<any>(this.integrationMisc + `Export/ToMyDocument?FolderName=${folderName}&FileName=${encodeURIComponent(fileName)}&FileExtension=${extension}`, formData);
    }
    getFileDownloadLinkById(attachmentId: number): Observable<any> {
        return this.http.get<any>(this.documentsStorageUrl + `CloudAttachment/${attachmentId}`);
    }
}
